import { Action, combineReducers } from '@ngrx/store';

import {
  _CLEAR,
  RESET_PRINTER_CONFIG_VIEW,
  SET_PRINTER_CONFIG_VIEW
} from '../actions';

import { INACTIVE } from '../printer-statuses';

const initialPrinterConfigState = {
  error          : <string>'',
  loading        : <boolean>false,
  networkInfo    : <any>null,
  printer        : <string>'',
  printers       : <string[]>null,
  selectedPrinter: <string>'',
  status         : <string>INACTIVE,
  version        : <string>''
};

export function printerConfigurationReducer(state = initialPrinterConfigState, action: Action) {
  switch (action.type) {
    case _CLEAR:
      return Object.assign({}, state, initialPrinterConfigState);
    case RESET_PRINTER_CONFIG_VIEW:
      return Object.assign({}, state, initialPrinterConfigState);
    case SET_PRINTER_CONFIG_VIEW:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}

export const printerReducers = combineReducers({
  printerConfiguration: printerConfigurationReducer
});



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/ngrx/reducers/printers.ts